import { DropdownFilter, TextCaption } from '@carboncopyco/ui';
import { useMemo } from 'react';
import { useDemoLinkRevision } from './DemoLinkModalContext';

const genetrateRevision = (
  revisionNumber: number
): { id: string; label: string }[] => [
  { id: 'autoSync', label: 'Auto sync: Latest' },
  {
    id: `${revisionNumber + 1}`,
    label: `Version: ${revisionNumber + 1} (current)`,
  },
  ...Array.from({ length: revisionNumber }, (_, index) => ({
    id: String(index + 1),
    label: `Version ${index + 1}`,
  })).sort((a, b) => Number(b.id) - Number(a.id)),
];

export const DemoLinkRevision = ({
  latestRevision,
  disabled,
}: {
  latestRevision: number;
  disabled?: boolean;
}) => {
  const [revisionId, setRevisionId] = useDemoLinkRevision();
  const revisions = useMemo(
    () => genetrateRevision(latestRevision),
    [latestRevision]
  );
  return (
    <div className="w-80">
      <div className="text-ds-accent2-500">
        <TextCaption label="Demo version" />
      </div>
      <DropdownFilter
        disabled={disabled}
        size="medium"
        rounded={false}
        contentWidth="full"
        capsuleWidth="full"
        selected={revisionId}
        placeholder="Demo version"
        items={revisions}
        onSelect={setRevisionId}
      />
    </div>
  );
};
